import React from "react";
import { useTranslation } from "locales";
import BlockUniversityCTA from "./components/BlockUniversityCTA";
import BlockUniversityPartnerships from "./components/BlockUniversityPartnerships";
import BlockUniversityStats from "./components/BlockUniversityStats";
import BaseButton from "../../../../components/BaseButton";
import BaseIcon from "../../../../components/BaseIcon";
import useModalLinkPrinter from "../../../../hooks/useModalLinkPrinter";
import "./style.scss";

export default function BlockUniversities() {
  const { t } = useTranslation();
  const { getLocation } = useModalLinkPrinter();

  return (
    <>
      <div className="block-universities d-flex __column __align-center">
        <h1 className="block-universities__title h1 mb-4 text-center">
          {t("Partnering with universities to strengthen student employability in financial services")}
        </h1>
        <div className="block-universities__description subtitle-1 text-neutral-darken-1 text-center">
          {t(
            "Enhance satisfaction. Protect rankings. A practical bridge from advanced study to career, built for MSc Finance and MBA cohorts."
          )}
        </div>
        <BaseButton
          className="block-universities__btn body-1 fw-bold pl-4 pr-3"
          to={getLocation("/contact-us")}
          large
          dark
        >
          {t("Book a discovery call")}
          <BaseIcon className="f-shrink-0 ml-2">chevron-right</BaseIcon>
        </BaseButton>
      </div>
      <BlockUniversityStats />
      <BlockUniversityPartnerships />
      <BlockUniversityCTA />
    </>
  );
}
